import Bluebird from 'bluebird';
import {
  getDonationLogs,
  getFoodDonorLogs,
  getPickupSpecLogs,
  getReceivingAgencyLogs,
  getRescueLogs,
  getUserLogs,
} from '../api/logs';

export const REQUEST_LOGS = 'REQUEST_LOGS';
export const RECEIVE_USER_LOGS = 'RECEIVE_USER_LOGS';
export const RECEIVE_RESCUE_LOGS = 'RECEIVE_RESCUE_LOGS';
export const RECEIVE_PICKUP_SPEC_LOGS = 'RECEIVE_PICKUP_SPEC_LOGS';
export const RECEIVE_DONATION_LOGS = 'RECEIVE_DONATION_LOGS';
export const RECEIVE_FOOD_DONOR_LOGS = 'RECEIVE_FOOD_DONOR_LOGS';
export const RECEIVE_RECEIVING_AGENCY_LOGS = 'RECEIVE_RECEIVING_AGENCY_LOGS';

export const requestLogs = () => ({
  type: REQUEST_LOGS,
});

export const receiveUserLogs = (userId, logs) => ({
  type: RECEIVE_USER_LOGS,
  userId,
  logs,
  receivedAt: Date.now(),
});

export const receiveRescueLogs = (rescueId, logs) => ({
  type: RECEIVE_RESCUE_LOGS,
  rescueId,
  logs,
  receivedAt: Date.now(),
});

export const receivePickupSpecLogs = (pickupSpecId, logs) => ({
  type: RECEIVE_PICKUP_SPEC_LOGS,
  pickupSpecId,
  logs,
  receivedAt: Date.now(),
});

export const receiveDonationLogs = (donationId, logs) => ({
  type: RECEIVE_DONATION_LOGS,
  donationId,
  logs,
  receivedAt: Date.now(),
});

export const receiveFoodDonorLogs = (foodDonorId, logs) => ({
  type: RECEIVE_FOOD_DONOR_LOGS,
  foodDonorId,
  logs,
  receivedAt: Date.now(),
});

export const receiveReceivingAgencyLogs = (receiverId, logs) => ({
  type: RECEIVE_RECEIVING_AGENCY_LOGS,
  receiverId,
  logs,
  receivedAt: Date.now(),
});

export const fetchUserLogs = (userId) => (dispatch) => {
  dispatch(requestLogs());

  return Bluebird.try(() => getUserLogs(userId))
    .then((res) => res.json())
    .then((json) => dispatch(receiveUserLogs(userId, json.data)))
    .catch(() => dispatch(receiveUserLogs(userId, [])));
};

export const fetchRescueLogs = (rescueId) => (dispatch) => {
  dispatch(requestLogs());

  return Bluebird.try(() => getRescueLogs(rescueId))
    .then((res) => res.json())
    .then((json) => dispatch(receiveRescueLogs(rescueId, json.data)))
    .catch(() => dispatch(receiveRescueLogs(rescueId, [])));
};

export const fetchPickupSpecLogs = (pickupSpecId) => (dispatch) => {
  dispatch(requestLogs());

  return Bluebird.try(() => getPickupSpecLogs(pickupSpecId))
    .then((res) => res.json())
    .then((json) => dispatch(receivePickupSpecLogs(pickupSpecId, json.data)))
    .catch(() => dispatch(receivePickupSpecLogs(pickupSpecId, [])));
};

export const fetchDonationLogs = (donationId) => (dispatch) => {
  dispatch(requestLogs());

  return Bluebird.try(() => getDonationLogs(donationId))
    .then((res) => res.json())
    .then((json) => dispatch(receiveDonationLogs(donationId, json.data)))
    .catch(() => dispatch(receiveDonationLogs(donationId, [])));
};

export const fetchFoodDonorLogs = (foodDonorId) => (dispatch) => {
  dispatch(requestLogs());

  return Bluebird.try(() => getFoodDonorLogs(foodDonorId))
    .then((res) => res.json())
    .then((json) => dispatch(receiveFoodDonorLogs(foodDonorId, json.data)))
    .catch(() => dispatch(receiveFoodDonorLogs(foodDonorId, [])));
};

export const fetchReceivingAgencyLogs = (receiverId) => (dispatch) => {
  dispatch(requestLogs());

  return Bluebird.try(() => getReceivingAgencyLogs(receiverId))
    .then((res) => res.json())
    .then((json) => dispatch(receiveReceivingAgencyLogs(receiverId, json.data)))
    .catch(() => dispatch(receiveReceivingAgencyLogs(receiverId, [])));
};
